const predictProductId = window.__env__?.PREDICT_PRODUCT_ID?.trim();

if (!predictProductId) {
  throw new Error('PREDICT_PRODUCT_ID must be configured in the runtime environment.');
}

export const PREDICT_PRODUCT_ID = predictProductId;
export const WSC_API_URL = window.__env__.API_URL;
